import { Action, Dispatch } from "redux";
import { GameConfig } from "../../dto/game/GameConfig";
import { GiftGameDTO } from "../../dto/game/GameInitResDto";
import { QuestionDTO } from "../../dto/game/GameInitSurveyResDto";
import { MemberInfo } from "../../dto/game/MemberInfo";
import { FGetState } from "../app.reducer";

/**
 * Functon type declare
 */
export type FuncAction = (
  dispatch: Dispatch,
  getState: FGetState
) => Promise<void>;

/**
 * Function sync type declare
 */
export type FuncSyncAction = (dispatch: Dispatch, getState: FGetState) => void;

/**
 * Cart action type declare
 */
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  INIT: {
    LOADING: "GAME_INIT_LOADING",
    SUCCESS: "GAME_INIT_SUCCESS",
    ERROR: "GAME_INIT_ERROR",
  },
  INFO: {
    LOADING: "GAME_INFO_LOADING",
    SUCCESS: "GAME_INFO_SUCCESS",
    ERROR: "GAME_INFO_ERROR",
  },
  RESULT: {
    LOADING: "GAME_RESULT_LOADING",
    SUCCESS: "GAME_RESULT_SUCCESS",
    ERROR: "GAME_RESULT_ERROR",
  },
  REGISTER: {
    LOADING: "GAME_REGISTER_LOADING",
    SUCCESS: "GAME_REGISTER_SUCCESS",
    ERROR: "GAME_REGISTER_ERROR",
  },
  GAME_CODE: {
    SAVE: "GAME_CODE_SAVE",
    CLEAR: "GAME_CODE_CLEAR",
  },
  INIT_SURVEY: {
    LOADING: "GAME_INIT_SURVEY_LOADING",
    SUCCESS: "GAME_INIT_SURVEY_SUCCESS",
    ERROR: "GAME_INIT_SURVEY_ERROR",
  },
  SAVE_SURVEY: {
    LOADING: "GAME_SAVE_SURVEY_LOADING",
    SUCCESS: "GAME_SAVE_SURVEY_SUCCESS",
    ERROR: "GAME_SAVE_SURVEY_ERROR",
  },
  UPLOAD_SURVEY: {
    LOADING: "GAME_UPLOAD_SURVEY_LOADING",
    SUCCESS: "GAME_UPLOAD_SURVEY_SUCCESS",
    ERROR: "GAME_UPLOAD_SURVEY_ERROR",
  },
};

/**
 * All address states
 */
export interface GameState {
  rewardList: Array<GiftGameDTO>;
  memberInfo: MemberInfo;
  configList: Array<GameConfig>;
  gameCode?: string;
  isVM?: boolean;
  questionInfo?: QuestionDTO;
  isLoading: boolean
}

/**
 * Address's action definition
 */
export interface IGameAction extends Action {
  payload: any;
}
